module.exports = __webpack_public_path__ + "static/media/icon-lock-gray.bd4b2bba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-lock-gray.svg
// module id = ./src/assets/images/icon-lock-gray.svg
// module chunks = 0